import React from 'react';
import PROXI_BRAIN_LOGO from '@/ui/assets/images/proxivideobrainlogo.png';
import { LightShell, LightMark, LightSpinner } from '../light-ui';

const Loading: React.FC = () => {
  return (
    <LightShell>
      <main
        style={{
          minHeight: '100dvh',
          display: 'grid',
          placeItems: 'center',
          padding: 'clamp(20px, 6vh, 56px) clamp(20px, 6vw, 80px)',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 28, textAlign: 'center', maxWidth: 460 }}>
          <LightMark src={PROXI_BRAIN_LOGO} size={72} imgScale={0.72} />

          <span className="lp-frost-chip">
            <span
              style={{
                width: 7, height: 7, borderRadius: 99,
                background: 'var(--lp-pink)',
                boxShadow: '0 0 12px var(--lp-pink)',
                animation: 'lp-pulse 2.2s ease-in-out infinite',
              }}
            />
            Preparing session
          </span>

          <h1 className="lp-section-heading">Setting things up for you.</h1>
          <p className="lp-prose" style={{ maxWidth: 360 }}>
            One moment while we tune the room. This usually takes just a few seconds.
          </p>

          <LightSpinner size={36} />
        </div>
      </main>

      <footer
        style={{
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          bottom: 'calc(env(safe-area-inset-bottom, 0px) + 18px)',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
        }}
        role="contentinfo"
      >
        <span className="lp-footer-link">
          Powered by{' '}
          <a href="https://www.ProxiAIStudio.com" target="_blank" rel="noopener noreferrer">
            ProxiAIStudio.com
          </a>
        </span>
      </footer>
    </LightShell>
  );
};

export default Loading;
